import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-banner-v4',
  templateUrl: './banner-v4.component.html',
  styleUrls: ['./banner-v4.component.scss']
})
export class BannerV4Component implements OnInit {

  @Input() pageTitle: any;

  constructor() { }

  ngOnInit(): void {
  }

}
